module.exports = __webpack_public_path__ + "img/close.5da1e8d8.svg";